// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upa3gh0 {
  width: 100%;
  background-color: var(--_18w76bw2z);
  aspect-ratio: 27 / 15;
  max-width: 300px;
}
.upa3gh1 {
  border-radius: 6px;
  padding: 6px;
  font-size: var(--_18w76bw3p);
}
.upa3gh2 {
  border-radius: 16px;
  padding: var(--_18w76bwg);
  font-size: var(--_18w76bw3u);
}
.upa3gh3 {
  opacity: 0.4;
  border-radius: 16px;
  padding: var(--_18w76bwg);
  font-size: var(--_18w76bw3u);
}
@media screen and (min-width: 768px) {
  .upa3gh2 {
    padding: var(--_18w76bwi);
  }
  .upa3gh3 {
    padding: var(--_18w76bwi);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mCAAmC;EACnC,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".upa3gh0 {\n  width: 100%;\n  background-color: var(--_18w76bw2z);\n  aspect-ratio: 27 / 15;\n  max-width: 300px;\n}\n.upa3gh1 {\n  border-radius: 6px;\n  padding: 6px;\n  font-size: var(--_18w76bw3p);\n}\n.upa3gh2 {\n  border-radius: 16px;\n  padding: var(--_18w76bwg);\n  font-size: var(--_18w76bw3u);\n}\n.upa3gh3 {\n  opacity: 0.4;\n  border-radius: 16px;\n  padding: var(--_18w76bwg);\n  font-size: var(--_18w76bw3u);\n}\n@media screen and (min-width: 768px) {\n  .upa3gh2 {\n    padding: var(--_18w76bwi);\n  }\n  .upa3gh3 {\n    padding: var(--_18w76bwi);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
